<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->

            <div v-show="mode === MODE.SEARCH">

                <!-- srchTop_wrap -->
                <div class="srchTop_wrap srchFaq_wrap extend">
                    <article class="srch_basic">
                        <dl class="dl_search">
                            <dd data-input-type="select">
                                <select
                                    name="productType"
                                    ref="productType"
                                    class="slt_white w100p "
                                    v-model="selectedContentsType"
                                >
                                    <option
                                        v-for="item in availableContentsTypeList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </dd>
                            <dd class="btn">
                                <a href="javascript:" class="btn_srch" @click="search(1)">
                                    {{ $t('FIELD.GLOBAL.SEARCH') }}
                                </a>
                            </dd>
                        </dl>
                        <!-- mobile_hide -->
                        <div class="top_mobile">
                            <div class="mobile_title">Category</div>
                            <dl class="dl_select">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p"
                                        v-model="selectedProductType"
                                        @change="onProductTypeChange($event)"
                                    >
                                        <option
                                            v-for="item in availableProductTypeList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </dd>
                            </dl>
                            <dl class="dl_select">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p"
                                        v-model="selectedProductSubType"
                                    >
                                        <option value="">Select Product Subtype</option>
                                        <option
                                            v-for="item in availableProductSubTypeList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </dd>
                            </dl>
                        </div>
                        <!-- //mobile_hide -->
                    </article>
                    <article class="srch_detail">
                        <dl class="dl_input">
                            <dt>Update Date</dt>
                            <dd data-input-type="date">
                                <fieldset class="ui_fieldset">
                                    <label class="date-wrap">
                                        <input
                                            id="fromDate"
                                            type="text"
                                            class="date_input w100p"
                                            placeholder="From Date"
                                            readonly maxlength="20"
                                        />
                                        <a href="javascript:" class="in_btn" id="icoFromDate">
                                            <i class="ico_date"></i> <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="from-picker-container" />
                                    <em class="txt_space"></em>
                                    <label class="date-wrap">
                                        <input
                                            id="toDate"
                                            type="text"
                                            class="date_input w100p"
                                            placeholder="To Date"
                                            readonly maxlength="20"
                                        />
                                        <a href="javascript:" class="in_btn" id="icoToDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;" />
                                </fieldset>
                            </dd>
                        </dl>
                        <dl class="dl_input">
                            <dt>Model Code
                                <em class="txt_mandatory">*</em>
                            </dt>
                            <dd class="clearable" data-input-type="input">
                                <input type="text" class="text_input w100p" placeholder="Model" v-model="model" maxlength="40" v-clearable>
                            </dd>
                            <dt>Modifier</dt>
                            <dd  class="clearable" data-input-type="input">
                                <input type="text" class="text_input w100p" placeholder="Modifier" v-model="addedName" maxlength="40" v-clearable>
                            </dd>
                        </dl>
                        <dl class="dl_input">
                            <dt>Subject</dt>
                            <dd class="clearable" data-input-type="input">
                                <input type="text" class="text_input w100p" placeholder="Enter keyword" v-model="title"
                                    maxlength="40" v-clearable>
                            </dd>
                        </dl>
                    </article>
                </div>

                <div >
                    <!-- Grid -->
                    <div class="grid_wrap">
                        <!-- Grid Count-->
                        <div class="grid_total">
                            Total Count
                            <em>{{ resultCount | numberFormat }}</em>
                        </div>
                        <!-- Grid "btn-->
                        <div>
                            <toast-grid
                                gridId="gridCategorySearch"
                                :key="gridKey"
                                :data="gridData"
                                :columns="gridColumns"
                                :header="gridHeader"
                                :options="gridOptions"
                                :pageOptions="gridPageOptions"
                                :theme="gridTheme"
                                :isTotalCount="false"
                                v-bind:click="onGridCellClick"
                            />
                        </div>
                    </div>
                    <div class="paginate">
                        <sdl-pagination
                            :current-page="currentPage"
                            :total-rows="resultCount"
                            :per-page="perPage"
                            @change="search"
                            align="center"
                        />
                    </div>
                </div>

            </div>

            <fragment v-if="mode === MODE.VIEW">
                <cms-detail
                    :cttid="cttid"
                    :prodType="prodType"
                    :prodSubType="prodSubType"
                    v-on:back-to-list="onBackToList" />
            </fragment>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

import $ from 'jquery';
import qs from 'query-string';
import moment from 'moment';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import { SDLUtil, DateUtil } from '@/utils';

import DatePicker from '~c/DatePicker';

import ToastGrid from '~c/ToastGrid';
import Pagination from '@/components/common/control/pagination/Pagination';

import { CellHtmlRenderer, HeaderHtmlRenderer, } from '~c/GridCustomRenderer';

import CmsDetail from './CmsDetail';

const MODE = {
    SEARCH: 'search',
    VIEW: 'view',
};

export default {
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,

        'cms-detail': CmsDetail,
    },
    data() {
        return {
            MODE,

            pageTitle: '',

            mode: MODE.SEARCH,

            availableProductTypeList: [],
            availableProductSubTypeList: [],
            availableContentsTypeList: [],

            selectedProductType: '',
            selectedProductSubType: '',
            selectedContentsType: '',

            model: '',
            title: '',
            addedName: '',

            cttid: '',
            prodType: '',
            prodSubType: '',

            rangePicker: null,

            searchToAddDt: '',
            searchFromAddDt: '',

            startDate: {},
            endDate: {},

            resultCount: 0,
            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 20),

            gridKey: 0,

            gridHeader: {},

            gridColumns: [],
            gridData: [],

            gridOptions: {
                scrollX: true,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                },
            },
        };
    },

    computed: {
        ...mapGetters({
            params: 'getParams',
            corpCd: 'getCorpCd',
        }),
    },
    created() {
        this.initLoad();
        
        this.$nextTick(() => {
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'months').toDate(),
                (new moment()).toDate(),
            );
        });

    },
    mounted() {
    },
    methods: {
        async initLoad() {
            const data = await this.fetchInitData();
            this.setProductTypeList(data.category1);
            this.setContentsTypeList(data.contentsTypeList);
        },

        fetchInitData() {
            const path = '/basis/common/cmsContents/cmsContentsList.skp';
            const formData = {
                menuId: this.params.menuId,
                corpNo: this.corpCd,
            };
            return SDLUtil.getRequest(path, formData);
        },

        setProductTypeList(list) {
            list = list.map(item => {
                return {
                    CODE_ID: item.CDPRODTYPE,
                    CODE_NAME: item.NMPRODTYPE,
                };
            });
            list.unshift({
                CODE_ID: '',
                CODE_NAME: 'Select Product Type',
            });
            this.availableProductTypeList = list;
            this.selectedProductTypeList = '';
        },

        setContentsTypeList(list) {
            list = list.map(item => {
                return {
                    CODE_ID: item.CONTENTS_CD,
                    CODE_NAME: item.CONTENTS_DESC.replace('<BR>', ''),
                };
            });
            list.unshift({
                CODE_ID: '',
                CODE_NAME: 'Select Contents Type',
            });
            this.availableContentsTypeList = list;
            this.selectedContentsType = '';
        },

        async onProductTypeChange() {
            const data = await this.fetchProductSubTypeList(this.selectedProductType);

            if (data === false) {
                SDLUtil.alert({
                    title: 'Error',
                    msg: 'Error',
                })
                return false;
            }

            this.setProductSubTypeList(data.list);
        },

        setProductSubTypeList(list) {
            list = list.map(item => {
                return {
                    CODE_ID: item.CDPRODSUBTYPE,
                    CODE_NAME: item.NMPRODSUBTYPE,
                };
            });
            this.availableProductSubTypeList = list;
            this.selectedProductSubType = '';
        },

        fetchProductSubTypeList(productType) {
            const path = '/basis/common/cmsContents/cmsSubCategoryList.skp';
            const params = {
                cdProdType: productType,
            };
            return SDLUtil.getRequest(path, params);
        },

        async search(pageNo) {
            if (!this.validateForm()) return;

            const queries = {
                multi: 'N',
            };

            const path = '/basis/common/cmsContents/cmsContentsListSearch.skp?' + qs.stringify(queries) ;
            const formData = this.prepFormData(pageNo);
            SDLUtil.showLoadingBar(true);
            const data = await SDLUtil.postForm(path, formData);
            SDLUtil.showLoadingBar(false);

            this.resultCount = data.count;

            if (this.resultCount === 20 &&
                typeof data.list !== 'undefined' && data.list.length < 20
            ) {
                this.resultCount = data.list.length;
            }

            this.setGridHeader(data.header);
            this.setGridData(data.list);

            this.currentPage = pageNo;

            this.gridKey += 1;
        },

        prepFormData(pageNo) {

            const format = moment().toMomentFormatString('MM.dd.yyyy');
            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(format) : moment().formatWithJDF(format);

            const formData = {
                page: pageNo || 1,
                menuId: this.params.menuId,
                categoryRoot: 0,
                BOARD_ID: '',
                cdProdType: this.selectedProductType,
                cdProdSubType: this.selectedProductSubType,
                searchModel: this.model,
                contentsType: this.selectedContentsType,
                searchFromAddDt,
                searchToAddDt,
                searchID: this.addedName,
                searchTitle: this.title,
                ORDER_COLUMN: '',
                ORDER_ASC: 'ASC',
                ORDER_FLAG: 'N',
            };
            return formData;
        },

        validateForm() {
            if (this.model.length < 7) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please enter 7 or more characters for Model Code.',
                });
                return false;
            }

            if (this.selectedProductType === '') {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please select Product Type.',
                });
                return false;
            }

            if (this.selectedProductSubType === '') {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please select Product Sub type.',
                });
                return false;
            }

            return true;
        },

        setGridData(list) {
            // list = list.map(item => {
            //     item.
            //     return item;

            // });
            this.gridData = list;
        },

        setGridHeader(header) {
            this.gridHeader = {
                columns: header.map(item => {
                    return {
                        name: item.CONTENTS_CD,
                    };
                }),
            };

            const fixedColumns = [
                {
                    header: 'No.',
                    name: 'RNUM',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ];

            this.gridColumns = [
                ...fixedColumns,
                ...header.map(item => {
                    let width = 110;
                    let minWidth = null;
                    let resizable = false;
                    let className = null;
                    let align = 'center';
                    if (item.CONTENTS_DESC.toUpperCase() === 'SUBJECT') {
                        minWidth = 200;
                        width = null; // Free Size
                        resizable = true;
                        className = 'ftColor';
                        align = 'left';

                    } else if (item.CONTENTS_DESC.toUpperCase() === 'MODEL CODE') {
                        width = 130; // Free Size
                    }
                    return {
                        header: item.CONTENTS_DESC,
                        name: item.CONTENTS_CD,
                        minWidth,
                        width,
                        align,
                        className,
                        resizable,
                        sortable: false,
                    }; }
                ),
            ];

        },

        onGridCellClick(event, rowData) {
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);

            if (event.columnName.toUpperCase() === 'CTTDESC') {
                this.selectModel(row.CTTID, row.NMPRODTYPE, row.NMPRODSUBTYPE);
            }
        },

        selectModel(cttid, prodType, prodSubType) {
            this.cttid = String(cttid);
            this.prodType = prodType;
            this.prodSubType = prodSubType;

            this.switchMode(MODE.VIEW);
        },

        onBackToList(event) {
            this.switchMode(MODE.SEARCH);

            window.setTimeout(() => {
                window.scrollTo({
                    top: 5000, 
                    left: 0,
                });
            }, 500);
        },

        switchMode(mode) {
            this.mode = mode;
        },
    },
}
</script>

<style >

</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/cmsContents/CmsCategorySearch.vue